import { SET_EOD_FOR_DAY } from '../action-list'

export const setEodForDay = (date, data) => ({
  type: SET_EOD_FOR_DAY,
  date,
  data,
})
